import { useCallback } from 'react';
import { useModalStore } from '@/store';
import { buildTopicFeedbackPrefill } from '@/utils/topic_feedback';

/**
 * Opens FeedbackModal with topic-page context for compliance-related requests.
 */
export default function useTopicPageFeedback(topicSlug, topicName) {
  const { openModal } = useModalStore((s) => s.actions);

  return useCallback(() => {
    openModal('FeedbackModal', {
      isOpen: true,
      initialContent: buildTopicFeedbackPrefill({
        topicName,
        topicSlug,
      }),
    });
  }, [openModal, topicName, topicSlug]);
}
